export const encodeBase64 = (str: string): string => {
  return btoa(unescape(encodeURIComponent(str)));
};

export const decodeBase64 = (str: string): string => {
  const polishedString = str.replace(/\s/g, ''); // mobile safari support
  return decodeURIComponent(escape(atob(polishedString)));
};
